import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const random = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min + 1) + min);

export function createObjectURL(file: File): string {
  if (typeof window === "undefined") return "";
  return URL.createObjectURL(file);
}

// UID mapping utilities for Agora
export const getOriginalUidFromAgoraUid = (agoraUid: string): string => {
  return agoraUid.replace(/-host$/, "");
};

export const isHostAgoraUid = (agoraUid: string): boolean => {
  return agoraUid.endsWith("-host");
};

export const getCurrentUserOriginalUid = (): string | null => {
  return localStorage.getItem("currentUserOriginalUid");
};

export const getCurrentUserAgoraUid = (): string | null => {
  return localStorage.getItem("currentUserAgoraUid");
};

export const isCurrentUserHost = (): boolean => {
  return localStorage.getItem("currentUserIsHost") === "true";
};
